import type { Config } from "@jti/fe-common";

type ConsentReminderPopupConfig = {
  enabled?: boolean | null;
  maximumOccurancesPerYear?: number | null;
  consentExpirationLimit?: number | null;
  popUpDelay?: number | null;
  offerConsentName?: string;
  productInformationConsentName?: string;
  ploomClubConsentName?: string;
};

export const getConsentReminderConfig = (
  consentReminderPopup?: ConsentReminderPopupConfig | null,
  consentReminderMode: Config["consentReminderMode"] = "legacy"
) => ({
  isEnabled: Boolean(consentReminderPopup?.enabled) && consentReminderMode === "legacy",
  maximumOccurrencesPerYear: consentReminderPopup?.maximumOccurancesPerYear ?? 0,
  consentExpirationLimit: consentReminderPopup?.consentExpirationLimit ?? 0,
  popUpDelay: consentReminderPopup?.popUpDelay ?? 0,
  offerConsentName: consentReminderPopup?.offerConsentName,
  productInformationConsentName: consentReminderPopup?.productInformationConsentName,
  ploomClubConsentName: consentReminderPopup?.ploomClubConsentName,
});
